import { NButton, NDialog } from '@innersource-nn/novoui-react';
import React, { useState } from 'react';
import { ModalProps } from 'types/Modal';
import useDatasetDelete from 'views/Datasets/hooks/useDatasetDelete';

export interface DeleteDatasetProps extends ModalProps {
    label: string;
    datasetUri: string;
    terminationProtection: string;
}

const DeleteDatasetModal = ({
    label,
    datasetUri,
    terminationProtection,
    visible,
    onClose,
}: DeleteDatasetProps) => {
    const { datasetDelete, datasetArchive, loading } = useDatasetDelete({
        label,
        datasetUri,
        terminationProtection,
        onClose,
    });
    const [isArchive, setIsArchive] = useState(false);
    const [isDelete, setIsDelete] = useState(false);
    const [title, setTitle] = useState('Archive/delete dataset');

    const DeleteContent = () => {
        return (
            <div>
                <div className="py-16">
                    Are you sure you want to delete this dataset? This action is
                    permanent and cannot be undone.
                </div>
                <div className="flex justify-end items-center gap-16">
                    <NButton variant="outline" square onClick={onClose}>
                        Cancel
                    </NButton>
                    <NButton
                        variant="destructive"
                        square
                        onClick={datasetDelete}
                        isLoading={loading}
                    >
                        Delete permanently
                    </NButton>
                </div>
            </div>
        );
    };
    const ArchiveContent = () => {
        return (
            <div>
                <div className="py-16">
                    Are you sure you want to archive this dataset? You can
                    restore it later if needed.
                </div>
                <div className="flex justify-end items-center gap-16">
                    <NButton variant="outline" square onClick={onClose}>
                        Cancel
                    </NButton>
                    <NButton
                        variant="destructive"
                        square
                        onClick={() => datasetArchive()}
                        isLoading={loading}
                    >
                        Archive dataset
                    </NButton>
                </div>
            </div>
        );
    };

    return (
        <NDialog
            isVisible={visible}
            closeDialog={onClose}
            backgroundClose
            headline={title}
            size="medium"
            showDividers={false}
        >
            <div className="text-true-blue flex flex-col gap-16">
                {isArchive && <ArchiveContent />}
                {isDelete && <DeleteContent />}
                {!isArchive && !isDelete && (
                    <div className="flex flex-col gap-16">
                        <p>You have two options for managing this dataset:</p>
                        <div>
                            <b>Archive dataset:</b> Archiving the dataset will
                            remove it from the active view but all data will be
                            preserved and can be restored.
                        </div>
                        <div>
                            <b>Delete dataset:</b> This action will permanently
                            delete the dataset from our systems.
                        </div>
                        <div className="flex justify-end items-center gap-16">
                            <NButton
                                className="outline-red-button"
                                leftIcon="basket"
                                square
                                onClick={() => {
                                    setIsArchive(true);
                                    setTitle('Archive dataset');
                                }}
                            >
                                Archive
                            </NButton>
                            <NButton
                                className="outline-red-button"
                                leftIcon="trash"
                                square
                                onClick={() => {
                                    setIsDelete(true);
                                    setTitle('Delete dataset');
                                }}
                            >
                                Delete
                            </NButton>
                        </div>
                    </div>
                )}
            </div>
        </NDialog>
    );
};
export default DeleteDatasetModal;
